module.exports = __webpack_public_path__ + "static/img/perfil.9132153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/perfil.png
// module id = YJzi
// module chunks = 1